import {CheckoutModel} from '../models/checkout/Checkout.model';

export const isPartiallyPaid = (checkout: CheckoutModel) => Boolean(checkout.payLater?.total.amount);
export const hasFreeTrial = (checkout: CheckoutModel) => Boolean(checkout.payAfterFreeTrial?.total.amount);

export const getTotal = (checkout: CheckoutModel) =>
  !isPartiallyPaid(checkout)
    ? checkout.payNowTotalAfterGiftCard.formattedAmount
    : checkout.totalAfterGiftCard!.formattedAmount;
